<template>
  <component :is="colWrapper" v-bind="colProps">
    <b-form-group class="text-capitalize" :label="label" :label-for="id">
      <flat-pickr
        :value="value"
        @input="value => $emit('input', value)"
        id="delayed_record_minutes"
        class="form-control"
        :config="{
          enableTime: enableTime,
          dateFormat: dateFormat,
          time_24hr: true,
          minuteIncrement: minuteIncrement,
          mode: mode,
          allowInput: false,
          onReady: rememberRangeDays,
          onChange: applyRangeDefaults,
        }"
      />
    </b-form-group>
  </component>
</template>

<script>
// /home/desarrolo_01/Sites/front-vue/src/views/hanwha/camera/Sidenav.vue
import { ValidationProvider } from "vee-validate";
import { watch, computed, ref } from "@vue/composition-api";
import vSelect from "vue-select";
import popperHelper from "@/libs/popper-helper";
import flatPickr from "vue-flatpickr-component";

export default {
  name: "BaseDateTime",
  components: {
    ValidationProvider,
    flatPickr,
  },
  props: {
    value: {
      default: "",
    },
    validation_field_name: {
      type: String,
      default: "",
    },
    rules: {
      type: [String, Object],
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: "single",
    },
    enableTime: {
      type: Boolean,
      default: true,
    },
    dateFormat: {
      type: String,
      default: "Y-m-d H:i",
    },
    defaultRangeTimes: {
      type: Boolean,
      default: false,
    },
    minuteIncrement: {
      type: Number,
      default: 5,
    },
    cols: {
      type: [String, Number],
      default: null,
    },
    getValidationState: {
      type: Function,
      default: () => {},
    },
  },
  setup(props) {
    const dateInput = ref("");
    let rangeDays = [];
    const rememberRangeDays = dates => {
      rangeDays = dates.map(date => date.toDateString());
    };
    const applyRangeDefaults = (dates, value, instance) => {
      if (!props.defaultRangeTimes || props.mode !== "range") return;

      const nextDays = dates.map(date => date.toDateString());
      if (nextDays.join("|") === rangeDays.join("|")) return;

      const previousDays = rangeDays;
      rememberRangeDays(dates);
      const adjustedDates = dates.map((date, index) => {
        const adjusted = new Date(date);
        if (previousDays[index] !== nextDays[index] || (dates.length === 1 && previousDays.length === 2)) {
          adjusted.setHours(
            index === 0 ? 0 : 23,
            index === 0 ? 0 : 59,
            index === 0 ? 0 : 59,
            0
          );
        }
        return adjusted;
      });
      instance.setDate(adjustedDates, false);
    };
    const colWrapper = computed(() => (props.cols ? "b-col" : "div"));

    const colProps = computed(() => (props.cols ? { cols: props.cols } : {}));

    return {
      dateInput,
      rememberRangeDays,
      applyRangeDefaults,
      colProps,
      colWrapper,
      withPopper: popperHelper.withPopper,
    };
  },
};
</script>

